import { apiCompatibilityInterceptor } from './core/interceptors/api-compatibility.interceptor';
import { provideAndorBaseUrl } from './shared/api/generated/api.base-url';
import { config } from '../environments/environment';
import { maintenanceInterceptor } from './core/interceptors/maintenance.interceptor';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import {
  MissingTranslationHandler,
  TranslateParser,
  provideTranslateService,
} from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { defaultHeadersInterceptor } from './core/interceptors/default-headers.interceptor';
import { CustomMissingTranslationHandler, CustomTranslateParser } from './shared/i18n/translation';
import { LanguageService, provideDateLocale } from './core/services/language.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAndorBaseUrl(config.backendUrl),
    provideZonelessChangeDetection(),
    provideAnimationsAsync(),
    provideHttpClient(
      withXhr(),
      withInterceptors([
        apiCompatibilityInterceptor,
        maintenanceInterceptor,
        defaultHeadersInterceptor,
      ])
    ),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: `.json?v=${process.env['APP_BUILD']}`,
      }),
      fallbackLang: 'en',
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: CustomMissingTranslationHandler,
      },
      parser: {
        provide: TranslateParser,
        useClass: CustomTranslateParser,
      },
    }),
    provideAppInitializer(() => inject(LanguageService).ready()),
    provideDateLocale(),
  ],
};
